import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  message,
  Pagination,
  Input,
  Popconfirm,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";
import { SearchOutlined } from "@ant-design/icons";
import { AudioOutlined } from "@ant-design/icons";

// import Search from "antd/es/input/Search";

const { Title } = Typography;
const { Search } = Input;

const columns = [
  {
    title: "#",
    key: "number",
    dataIndex: "number",
  },
  {
    title: "DATE",
    key: "date",
    dataIndex: "date",
  },
  // TODO Edited . PLEASE CHECK ND TEST ME !!!!!
  {
    title: "USER",
    key: "user",
    dataIndex: "user",
  },
  {
    title: "COMPANY",
    key: "company",
    dataIndex: "company",
  },
  {
    title: "LOCATION",
    dataIndex: "location",
    key: "location",
    // width: "25%",
  },
  {
    title: "ADDRESS",
    key: "address",
    dataIndex: "address",
  },
  // {
  //   title: "CLIENT",
  //   key: "client",
  //   dataIndex: "client",
  // },
  {
    title: "REGION",
    key: "region",
    dataIndex: "region",
  },
  {
    title: "COST CENTER",
    key: "costCenter",
    dataIndex: "costCenter",
  },
  // {
  //   title: "EMAIL",
  //   key: "email",
  //   dataIndex: "email",
  // },
  {
    title: "CONTROL TYPE",
    key: "controlType",
    dataIndex: "controlType",
  },
  {
    title: "PROBLEMS",
    key: "problems",
    dataIndex: "problems",
  },
  {
    title: "EVENT TYPE",
    key: "eventType",
    dataIndex: "eventType",
  },
  {
    title: "DESCRIPTION",
    key: "description",
    dataIndex: "description",
  },
  {
    title: "COMMENT",
    key: "comment",
    dataIndex: "comment",
  },
  {
    title: "ACTIONS",
    key: "actions",
    dataIndex: "actions",
  },
];

const suffix = (
  <AudioOutlined
    style={{
      fontSize: 16,
      color: "#1677ff",
    }}
  />
);

function ReportsPaged() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();
  const [messageApi2, contextHolder2] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [locations, setLocations] = useState();

  const [reports, setReports] = useState();
  const [totalReports, setTotalReports] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [order, setOrder] = useState("desc");
  const [loadingReports, setLoadingReports] = useState(false);
  const [query, setQuery] = useState("");
  const [selectedReportIds, setSelectedReportIds] = useState([]);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);

  const [usernames, setUsernames] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [clients, setClients] = useState([]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location ID copied to clipboard",
    });
  };

  const successDeleteMessage = () => {
    message.success("Report deleted successfully!");
  };
  const errorMessage = () => {
    message.error("Something went wrong. Please try again later.");
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleSearchQueryChange = (keyword) => {
    setQuery(keyword);
    setCurrentPage(1);
    setSelectedReportIds([]);
  };

  const deleteReport = async (reportId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL +
          `report/deleteReport?reportId=${reportId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      successDeleteMessage();
      setSelectedReportIds((prevSelected) =>
        prevSelected.filter((id) => id !== reportId)
      );
      getReportsPaged();
    } catch (error) {
      console.log(error);
      errorMessage();
    }
  };

  const deleteReportsBulk = async () => {
    if (!selectedReportIds.length) {
      return;
    }

    setIsBulkDeleting(true);
    const token = localStorage.getItem("token");

    try {
      const results = await Promise.allSettled(
        selectedReportIds.map((reportId) =>
          axios.delete(
            process.env.REACT_APP_API_URL +
              `report/deleteReport?reportId=${reportId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
        )
      );

      const rejected = results.filter((result) => result.status === "rejected");

      if (rejected.length === 0) {
        message.success(
          `Deleted ${selectedReportIds.length} report${
            selectedReportIds.length > 1 ? "s" : ""
          }.`
        );
      } else if (rejected.length === selectedReportIds.length) {
        message.error("Failed to delete the selected reports. Please try again.");
      } else {
        message.warning(
          "Some reports could not be deleted. Please refresh and try again."
        );
      }

      setSelectedReportIds([]);
      getReportsPaged();
    } catch (error) {
      console.log(error);
      message.error("Failed to delete the selected reports. Please try again.");
    } finally {
      setIsBulkDeleting(false);
    }
  };

  function convertISOToCustomFormat(isoDate) {
    // Create a Date object from the ISO date string
    const date = new Date(isoDate);

    // Get the current year, month, and day
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();
    const currentDay = date.getDate();

    // Check if the date falls within the Romanian winter time interval (usually ends in March)
    const isRomanianWinterTime =
      currentMonth === 9 ||
      currentMonth === 10 ||
      currentMonth === 11 ||
      currentMonth === 0 ||
      currentMonth === 1 ||
      currentMonth === 2;

    // Adjust the time zone offset based on the interval
    if (isRomanianWinterTime) {
      date.setUTCHours(date.getUTCHours() + 2);
    } else {
      date.setUTCHours(date.getUTCHours() + 3);
    }

    // Extract the date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Create the custom format string
    const customFormat = `${day}/${month}/${year} ${hours}:${minutes}`;

    return customFormat;
  }

  const data = reports?.map((report, index) => {
    return {
      key: report.report.id,
      number: (
        <>
          <div className="ant-employed">
            <span>{index + 1}</span>
          </div>
        </>
      ),
      date: (
        <>
          <div className="ant-employed">
            <span>
              {report?.report.createdAt
                ? convertISOToCustomFormat(report?.report.createdAt)
                : ""}
            </span>
          </div>
        </>
      ),
      // TODO Get user in different ways
      // user: (
      //   <>
      //     <Avatar.Group>
      //       <div
      //         className="avatar-info"
      //         // style={{ cursor: "pointer" }}
      //         // onClick={() => copyToClipBoard(location.id)}
      //       >
      //         <Title level={5}>
      //           {/*{report.userId ? getUser(report.userId) : null}*/}
      //           {usernames[index]}
      //           {/*<CopyOutlined style={{ color: "#1ec8ff" }} />*/}
      //         </Title>
      //         {/*<p>{location.locationCoordinates} </p>*/}
      //       </div>
      //     </Avatar.Group>{" "}
      //   </>
      // ),
      user: (
        <>
          <Avatar.Group>
            <div className="avatar-info">
              <Title level={5}>{report.username}</Title>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      company: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.societateDePaza
                ? report.report.societateDePaza
                : "N/A"}
            </span>
          </div>
        </>
      ),
      location: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.obiectiv ? report.report.obiectiv : "N/A"}
            </span>
          </div>
        </>
      ),
      address: (
        <>
          <div className="ant-employed">
            <span>{report.report.adresa ? report.report.adresa : "N/A"}</span>
          </div>
        </>
      ),
      region: (
        <>
          <div className="ant-employed">
            <span>{report.report.regiune ? report.report.regiune : "N/A"}</span>
          </div>
        </>
      ),
      costCenter: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.centruDeCost ? report.report.centruDeCost : "N/A"}
            </span>
          </div>
        </>
      ),

      controlType: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.tipulDeControl
                ? report.report.tipulDeControl
                : "N/A"}
            </span>
          </div>
        </>
      ),
      problems: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.neconformitati &&
              report.report.neconformitati === true
                ? "TRUE"
                : !report.report.neconformitati
                ? "FALSE"
                : "N/A"}
            </span>
          </div>
        </>
      ),
      eventType: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.tipulEvenimentului === "null"
                ? "N/A"
                : report.report.tipulEvenimentului}
            </span>
          </div>
        </>
      ),
      description: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.descriereaEvenimentului
                ? report.report.descriereaEvenimentului
                : "N/A"}
            </span>
          </div>
        </>
      ),
      comment: (
        <>
          <div className="ant-employed">
            <span>
              {report.report.observatii ? report.report.observatii : "N/A"}
            </span>
          </div>
        </>
      ),
      actions: (
        <>
          <div className="ant-employed">
            <Button
              onClick={() => deleteReport(report?.report.id)}
              type="danger"
            >
              Delete
            </Button>
          </div>
        </>
      ),
      // client: (
      //   <>
      //     <div className="ant-employed">
      //       <span>{clients[index] ? clients[index] : "N/A"}</span>
      //     </div>
      //   </>
      // ),
    };
  });

  const getReports = async () => {
    setLoadingReports(true);
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "report/getAllReports2",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      setReports(response.data);

      setUsernames([]);
      setCompanies([]);

      // TODO Get user in different ways
      // const users = response.data.map((report) => {
      //   getUser(report.userId);
      // });

      // console.log("USERS:", users);

      setLoading(false);
      setLoadingReports(false);
    } catch (error) {
      console.log(error);
    }
    setLoadingReports(false);
  };

  const getReportsPaged = async () => {
    setLoadingReports(true);
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `report/getReportsPagedWithSearch?page=${currentPage}&size=${pageSize}&ord=${order}&keyword=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      setReports(response.data.reports);
      setTotalReports(response.data.totalNumberOfItems);

      setUsernames([]);
      setCompanies([]);

      // TODO Get user in different ways
      // const users = response.data.map((report) => {
      //   getUser(report.userId);
      // });

      // console.log("USERS:", users);

      setLoading(false);
      setLoadingReports(false);
    } catch (error) {
      console.log(error);
    }
    setLoadingReports(false);
  };

  const exportReports = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportReportsToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "reports.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    // getReports();
    getReportsPaged();
  }, [currentPage, pageSize, query]);

  return (
    <>
      {contextHolder}
      {contextHolder2}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Reports"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Popconfirm
                    title={`Delete ${selectedReportIds.length} selected report${
                      selectedReportIds.length > 1 ? "s" : ""
                    }?`}
                    okText="Delete"
                    cancelText="Cancel"
                    okButtonProps={{ danger: true, loading: isBulkDeleting }}
                    onConfirm={deleteReportsBulk}
                    disabled={!selectedReportIds.length}
                  >
                    <Button
                      danger
                      style={{
                        marginRight: "10px",
                        marginBottom: "10px",
                        marginTop: "10px",
                      }}
                      disabled={!selectedReportIds.length}
                      loading={isBulkDeleting}
                    >
                      Delete Selected
                    </Button>
                  </Popconfirm>
                  <Search
                    placeholder="Search reports..."
                    enterButton="Search"
                    size="large"
                    // suffix={suffix}
                    onSearch={(value, _e) => handleSearchQueryChange(value)}
                    style={{
                      width: 300,
                      marginRight: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  />
                  {/*TODO Remove if no longer needed*/}
                  {/*<Input*/}
                  {/*  style={{*/}
                  {/*    marginRight: "10px",*/}
                  {/*    width: "200px",*/}
                  {/*    marginBottom: "10px",*/}
                  {/*    marginTop: "10px",*/}
                  {/*  }}*/}
                  {/*  size="small"*/}
                  {/*  prefix={*/}
                  {/*    <SearchOutlined*/}
                  {/*      size="small"*/}
                  {/*      // style={{*/}
                  {/*      //   backgroundColor: "red",*/}
                  {/*      //   padding: "0px",*/}
                  {/*      //   margin: "0px",*/}
                  {/*      //   height: "10px",*/}
                  {/*      // }}*/}
                  {/*      className="site-form-item-icon"*/}
                  {/*    />*/}
                  {/*  }*/}
                  {/*  placeholder="Search reports"*/}
                  {/*  onChange={(e) => handleSearchQueryChange(e.target.value)}*/}
                  {/*/>*/}
                  {/*<Button*/}
                  {/*  onClick={() => exportReports()}*/}
                  {/*  style={{*/}
                  {/*    marginBottom: "10px",*/}
                  {/*    marginTop: "10px",*/}
                  {/*    marginRight: "20px",*/}
                  {/*  }}*/}
                  {/*  type="secondary"*/}
                  {/*  className="tag-secondary"*/}
                  {/*>*/}
                  {/*  Export Reports*/}
                  {/*</Button>*/}
                  <Button
                    onClick={() => exportReports()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Reports
                  </Button>
                </div>
              }
            >
              <div className="table-responsive">
                {loading || loadingReports ? (
                  <Spinner />
                ) : (
                  <div>
                    <Table
                      style={{ padding: "10px" }}
                      columns={columns}
                      dataSource={data}
                      rowSelection={{
                        preserveSelectedRowKeys: true,
                        selectedRowKeys: selectedReportIds,
                        onChange: (selectedKeys) => setSelectedReportIds(selectedKeys),
                      }}
                      pagination={false}
                      className="ant-border-space"
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "30px",
                        marginRight: "10px",
                      }}
                    >
                      <Pagination
                        style={{ marginTop: "10px" }}
                        total={totalReports}
                        showTotal={(total, range) =>
                          `${range[0]}-${range[1]} of ${total} reports`
                        }
                        pageSize={pageSize}
                        current={currentPage}
                        onChange={handlePageChange}
                        onShowSizeChange={handlePageSizeChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ReportsPaged;
